module.exports = __webpack_public_path__ + "static/img/yhbg.83636a27.png";